// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qy-9";
export var arrowButtonContainer = "_qy-5";
export var arrowButtonIcon = "_qy-6";
export var carouselArrowButton = "_qy-2";
export var carouselElementContainer = "_qy-1";
export var currentSlide = "_qy-8";
export var left = "_qy-3";
export var otherSlide = "_qy-a";
export var productCarouselContainer = "_qy-0";
export var right = "_qy-4";
export var sliderOverflow = "_qy-7";